import { render, staticRenderFns } from "./user-tab.vue?vue&type=template&id=901204da&scoped=true"
import script from "./user-tab.vue?vue&type=script&lang=js"
export * from "./user-tab.vue?vue&type=script&lang=js"
import style0 from "./user-tab.vue?vue&type=style&index=0&id=901204da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901204da",
  null
  
)

export default component.exports